<template>
  <a-modal :title="title" :visible="visible" @ok="onOk" @cancel="onCancel">
    <a-form :form="form">
      <a-form-item v-if="id" label="国家ID" v-bind="layout">
        <a-input disabled :value="id" />
      </a-form-item>
      <a-form-item label="国家名称" v-bind="layout">
        <a-input v-decorator="['name', { rules: [{ required: true, message: '必填' }] }]" />
      </a-form-item>
      <a-form-item label="招聘类型" v-bind="layout">
        <a-checkbox-group
          v-decorator="[
            'recruitType',
            { initialValue: [], rules: [{ required: true, message: '必选' }] },
          ]"
        >
          <a-checkbox :value="0">社招</a-checkbox>
          <a-checkbox :value="1">校招</a-checkbox>
        </a-checkbox-group>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import * as apis from '@/apis';

export default {
  props: {
    id: Number,
    visible: Boolean,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      layout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
      },
    };
  },
  computed: {
    title() {
      return this.id ? '编辑国家' : '新增国家';
    },
  },
  watch: {
    async visible() {
      if (this.visible) {
        this.form.resetFields();

        if (this.id) {
          const result = await apis.getCountry(this.id);

          this.form.setFieldsValue({
            name: result.data.name,
            recruitType: result.data.recruitType
              .split(',')
              .filter(Boolean)
              .map(t => parseInt(t, 10)),
          });
        }
      }
    },
  },
  methods: {
    onOk() {
      this.form.validateFields(async (error, values) => {
        if (error) return;

        const data = { ...values, recruitType: values.recruitType.join(',') };

        await (this.id ? apis.updateCountry(data, this.id) : apis.createCountry(data));
        this.$message.success('保存成功');
        this.$emit('confirm');
      });
    },
    onCancel() {
      this.$emit('cancel');
    },
  },
};
</script>
